import React, {Component} from "react";
import styled from '@emotion/styled'
import sv from "../styles/marketing";
import {isMobileOnly} from "react-device-detect";
import packageInfo from "../../package.json";
import {Link} from "react-router-dom";
import {Trans, withTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFacebookF, faInstagram, faLinkedinIn, faMediumM, faTwitter} from "@fortawesome/free-brands-svg-icons";
import {StretchedBackground} from "./commons/StretchedBackground";
import {connect} from "react-redux";
import {authenticationState} from "../_constants/commons/authenticationState";

// STYLE ##########################################################

const FooterWrapper = styled('div')`
  margin-top: ${props => props.isMobile? sv.vEndSpacingXS + 'px' : sv.vEndSpacing + 'px'};
`;

const FooterContainer = styled('div')`
  display: flex;
  flex-direction: column;
	width: 100%;
  padding: 50px 0;
  @media(min-width: 1300px) {
    flex-direction: row;
  }
`;

const FooterContent = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
  bottom: 0;
  justify-content: space-between;
  width: 100%;
  ${props => props.isSecondary ? "max-width: 814px;" : ""}
  padding: 30px 0;
	@media(min-width: 1300px) {
    ${props => props.isSecondary ? "max-width: 30%;" : ""}
    padding-right: 50px;
  }
`;

const FooterSection = styled('div')`
  display: flex;
  flex-direction: column;
	flex: 1;
  padding: 20px 30px 20px 0;
  @media(max-width: 420px) {
    padding-left: 10px;
  }
`;

const FooterSectionTopic = styled('div')`
  position: relative;
  ${props => props.isMobile ? sv.h4 : sv.h3};
  color: ${sv.colors.quiet};
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  padding-bottom: 15px;
  white-space:nowrap;
`;

const FooterSectionSeparator = styled('div')`
  position: relative;
	border-top: 1px solid ${sv.colors.secondaryTrans};
	padding-bottom: 10px;
`;

const FooterSectionLink = styled('div')`
  position: relative;
  ${props => props.isMobile ? sv.h4 : sv.h3};
  color: ${sv.colors.quiet};
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  padding: 2px 0;
  white-space:nowrap;
  a {
    display: flex;
    color: ${sv.colors.quiet};
    &:visited {color: ${sv.colors.quiet};}
    &:hover {color: ${sv.colors.cta};}
  }
`;

const FooterSectionLinkIcon = styled(`div`)`
  width: 15px;
	margin-right:3px;
`;

const FooterText = styled('div')`
  position: relative;
  color: ${sv.colors.quiet};
  font-weight: 400;
  font-size: 15px;
	line-height: 20px;
  text-align: left;
  padding: 20px 0;
  -webkit-text-size-adjust: 100%;
  a {
    color: ${sv.colors.cta};
    &:visited {color: ${sv.colors.cta};}
    &:hover {color: ${sv.colors.cta};}
	  text-decoration: underline;
  }
  @media(max-width: 420px) {
    padding-left: 10px;
  }
`;

const VersionTip = styled('div')`
  position: absolute;
  top: -10px;
  box-shadow: 0 0 12px rgba(0,0,0,.75);
  border-radius: 4px;
  transition: bottom .1s ease-out, opacity .2s ease-out;
  font-size: 15px;
  line-height: 8px;
  letter-spacing: .5px;
  font-weight: 300;
  padding: 5px;
  opacity: ${props => props.show ? 0.7 : 0};
  text-transform: none;
`;

// COMPONENT ##########################################################
class Footer extends Component {

    constructor(props) {
      super(props);
      this.handleCopyrightPress = this.handleCopyrightPress.bind(this);
    }

    state = {
        show: false,
        clicks: 0
    };

    handleCopyrightPress() {
	    this.setState((prevState) => { return {clicks: prevState.clicks + 1} });
	    if(this.state.clicks > 4) {
	    	this.setState({show: true})
		    setTimeout(() => this.setState({show: false, clicks: 0}), 2000);
	    }
    }

    render() {
        const {t, authState} = this.props;
        const isLoggedIn = (authState === authenticationState.LOGGED_IN);
        
        return (
            <FooterWrapper isMobile={isMobileOnly}><StretchedBackground backgroundColor={sv.colors.body}>
                {/* footer background whole width */}
                <FooterContainer>
                    {/* footer link sections contents */}
                    <FooterContent isMobile={isMobileOnly}>

                        {/* Product */}
                        <FooterSection>
                            <FooterSectionTopic>{t('Product')}</FooterSectionTopic>
                            <FooterSectionSeparator />
                            <FooterSectionLink>
                                <a href="/pricing">{t('Pricing')}</a>
                            </FooterSectionLink>
                            { !isLoggedIn &&
                                <>
                                    <FooterSectionLink>
                                        <Link to="/signup">{t('Sign up')}</Link>
                                    </FooterSectionLink>
                                    <FooterSectionLink>
                                        <Link to="/signin">{t('Sign In')}</Link>
                                    </FooterSectionLink>
                                </>
                            }
                        </FooterSection>

                        {/* Company */}
                        <FooterSection>
                            <FooterSectionTopic>{t('Company')}</FooterSectionTopic>
                            <FooterSectionSeparator />
                            <FooterSectionLink>
                                <a href="/about">{t('About')}</a>
                            </FooterSectionLink>
                            <FooterSectionLink>
                                <Link to={{pathname: "https://blog.gistify.ai"}} target="_blank">{t('Blog')}</Link>
                            </FooterSectionLink>
                            <FooterSectionLink>
                                <a href="/terms">{t('Terms of Service')}</a>
                            </FooterSectionLink>
                            <FooterSectionLink>
                                <a href="/privacy">{t('Privacy Policy')}</a>
                            </FooterSectionLink>
                            <FooterSectionLink>
                                <a href="/faq">{t('FAQ')}</a>
                            </FooterSectionLink>
                            <FooterSectionLink>
                                <a href={"mailto:support@gistify.ai"}>{t('Contact Us')}</a>
                            </FooterSectionLink>
                        </FooterSection>

                        {/* Social */}
                        <FooterSection>
                            <FooterSectionTopic>{t('Social')}</FooterSectionTopic>
                            <FooterSectionSeparator />
                            <FooterSectionLink>
                                <Link to={{pathname: "https://medium.com/gistify"}} target="_blank">
                                    <FooterSectionLinkIcon><FontAwesomeIcon icon={faMediumM}
                                                                            size="sm"/></FooterSectionLinkIcon>
                                    {t('Medium')}
                                </Link>
                            </FooterSectionLink>
                            <FooterSectionLink>
                                <Link to={{pathname: "https://facebook.com/gistifyai"}} target="_blank">
                                    <FooterSectionLinkIcon><FontAwesomeIcon icon={faFacebookF}
                                                                            size="sm"/></FooterSectionLinkIcon>
                                    {t('Facebook')}
                                </Link>
                            </FooterSectionLink>
                            <FooterSectionLink>
                                <Link to={{pathname: "https://instagram.com/gistify.ai"}} target="_blank">
                                    <FooterSectionLinkIcon><FontAwesomeIcon icon={faInstagram}
                                                                            size="sm"/></FooterSectionLinkIcon>
                                    {t('Instagram')}
                                </Link>
                            </FooterSectionLink>
                            <FooterSectionLink>
                                <Link to={{pathname: "https://twitter.com/gistify_ai"}} target="_blank">
                                    <FooterSectionLinkIcon><FontAwesomeIcon icon={faTwitter}
                                                                            size="sm"/></FooterSectionLinkIcon>
                                    {t('Twitter')}
                                </Link>
                            </FooterSectionLink>
                            <FooterSectionLink>
                                <Link to={{pathname: "https://linkedin.com/company/gistify"}} target="_blank">
                                    <FooterSectionLinkIcon><FontAwesomeIcon icon={faLinkedinIn}
                                                                            size="sm"/></FooterSectionLinkIcon>
                                    {t('LinkedIn')}
                                </Link>
                            </FooterSectionLink>
                        </FooterSection>
                    </FooterContent>

                    {/* footer copyright sections contents */}
                    <FooterContent isMobile={isMobileOnly} isSecondary={true}>
                        <FooterText>
                            <Trans i18nKey="footer_company_info_with_link" ns={"footer"}>
	                            Gist is a mission-focused company. We are dedicated to making the exponentially expanding world of information quicker and easier to grow. If you'd like to work or partner with us, please <a href="mailto:support@gistify.ai">get in touch</a> with us and we can start a conversation.
                            </Trans>
                        </FooterText>
                        <FooterText
                            onMouseDown={(e) => this.handleCopyrightPress(e)}
                            onTouchStart={(e) => this.handleCopyrightPress(e)}>
                            <VersionTip show={this.state.show}>{packageInfo.version}</VersionTip>
                            &copy; TimeCloud
                        </FooterText>
                    </FooterContent>
                </FooterContainer>
            </StretchedBackground></FooterWrapper>
        )
    }
}

function mapStateToProps(state){
    const {authentication} = state;
    const {authState} = authentication;
    return {
        authState
    }
}

const connectedFooter = withTranslation("footer")(connect(mapStateToProps)(Footer));
export default connectedFooter;